import React from 'react';
import { motion } from 'framer-motion';
interface CtaButtonProps {
  label: string;
  subline?: string;
  className?: string;
}
export function CtaButton({
  label,
  subline,
  className = ''
}: CtaButtonProps) {
  return <motion.a href="https://colorpack.online/cart/47899538817163:1?storefront=true" target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`block w-full max-w-md mx-auto bg-[#5d4a6e] hover:bg-[#4a3b5c] text-white text-center py-4 px-6 rounded-xl shadow-lg transition-colors duration-300 ${className}`} data-id="element-12">
      <span className="block text-xl md:text-2xl font-bold font-sans mb-1" data-id="element-13">
        {label}
      </span>
      {subline && <span className="block text-sm md:text-base opacity-90 font-medium" data-id="element-14">
          {subline}
        </span>}
    </motion.a>;
}